"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subdisciplineGetParentId = void 0;
const subDisciplineParentMapping_1 = require("../../data/subDisciplineParentMapping");
const subdisciplineGetParentId = (subDisciplineId) => {
    return subDisciplineParentMapping_1.subDisciplineParentMapping[subDisciplineId] || null;
};
exports.subdisciplineGetParentId = subdisciplineGetParentId;
//# sourceMappingURL=discipline-get-parent-discipline.js.map